import { render, staticRenderFns } from "./CompensationHeader.vue?vue&type=template&id=63025170"
import script from "./CompensationHeader.vue?vue&type=script&lang=js"
export * from "./CompensationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports